// Persists the Quick Assessor workspace across page refreshes: the selected
// CID and the selected property. All of this lives in localStorage (per user /
// per browser) so no schema change or server round-trip is needed. Every access
// is wrapped — private-mode, quota, or SSR failures degrade to a no-op instead
// of throwing.

const CID_KEY = "qa.selectedCid";
const PROPERTY_KEY = "qa.selectedPropertyId";

const safeGet = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* ignore — storage unavailable */
  }
};

const safeRemove = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore — storage unavailable */
  }
};

const toId = (raw) => {
  if (raw === null || raw === "") return null;
  const num = Number(raw);
  return Number.isFinite(num) ? num : null;
};

// --- selected CID ---------------------------------------------------------
export const persistSelectedCid = (cid) => {
  if (cid === "" || cid === null || cid === undefined) {
    safeRemove(CID_KEY);
  } else {
    safeSet(CID_KEY, String(cid));
  }
};

export const readSelectedCid = () => toId(safeGet(CID_KEY));

// --- selected property ----------------------------------------------------
export const persistSelectedProperty = (id) => {
  if (id === null || id === undefined || id === -1) {
    safeRemove(PROPERTY_KEY);
  } else {
    safeSet(PROPERTY_KEY, String(id));
  }
};

export const readSelectedProperty = () => toId(safeGet(PROPERTY_KEY));
